import { Button } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@webuild-ai/react-auth";
import { useBrand } from "@webuild-ai/react-auth";

import DefaultLayout from "@/layouts/default"; // Import DefaultLayout
import { title } from "@/components/primitives"; // Import title
import { useTheme } from "@/hooks/use-theme";

const LoginPrompt = () => {
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth();
  const { brand } = useBrand();
  const { theme } = useTheme();

  const BrandLogo = theme === "dark" && brand.logoDark ? brand.logoDark : brand.logo;

  return (
    <DefaultLayout>
      <section className="flex flex-col h-full items-center justify-center gap-4 py-8 md:py-10">
        {brand.name && (
          <div className="inline-block max-w-lg  text-center justify-center">
            {brand.showLogo ? (
              <BrandLogo className="mx-auto mb-10" size={brand.menuItemsIconSize || 60} />
            ) : (
              <>
                <span className={title()}>{brand.name}&nbsp;</span>
                <span className={`${title()} text-primary`}>{"Pathway"}&nbsp;</span>
              </>
            )}
            <div className="login-prompt">
              <div className="login-content">
                <Button
                  className="btn-brand-primary text-sm"
                  data-id="login-button"
                  size="lg"
                  onPress={() => void loginWithRedirect()}
                >
                  {t("Login")}
                </Button>
              </div>
            </div>
          </div>
        )}
      </section>
    </DefaultLayout>
  );
};

export default LoginPrompt;
